module.exports = __webpack_public_path__ + "static/img/call.6eb0b9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newWx/call.png
// module id = V0St
// module chunks = 0